// extracted by mini-css-extract-plugin
export var image = "FullWidthImage-module--image--656Vo";
export var short = "FullWidthImage-module--short--nrbDt";